import React, { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import {
  alertIconStyles, alertStyles, containerStyles, closeIconStyles, headingStyles,
  contentStyles
} from './styles/Alert.css';

class Alert extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      additionalStyles: {}
    };
  }

  closeAlert = (e) =>  {
    if(this.props.isOpen && e.keyCode === 27) {
      this.props.onRequestClose();
    }
  };


  getStyles = (type, size) => {
    let baseStyles = alertStyles(type, size);
    if(this.state.additionalStyles)
      Object.assign(baseStyles, this.state.additionalStyles);
    return baseStyles;
  };

  componentDidMount() {
    document.addEventListener('keydown', this.closeAlert, false);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.additionalStyles && nextProps.additionalStyles !== this.state.additionalStyles)
      this.setState({ additionalStyles: nextProps.additionalStyles });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.closeAlert, false);
  }

  render() {
    let { type, size, isOpen } = this.props;

    if(isOpen)
      return (
      <div>
        <div className={'container modal fade show'} style={containerStyles}>
          <div className={'modal-backdrop fade show'} />
          <div className={`container alert ${type}`} role={'alert'} style={this.getStyles({ type, size })}>
            <div className={'container-fluid'}>
              <div className={'alert-icon'} aria-hidden="true" style={alertIconStyles}>
                <i className={'material-icons'}>{this.props.iconType}</i>
              </div>
              <i className={'material-icons float-right'} style={closeIconStyles}
                 onClick={this.props.onRequestClose}>close</i>
              <span>
              <b style={headingStyles}>{this.props.heading}:</b>
              <span style={contentStyles}>{this.props.content}</span>
            </span>
            </div>
          </div>
        </div>
      </div>
    );
    else return null;
  }
}

Alert.propTypes = {
  //Should the alert be shown
  isOpen: PropTypes.bool.isRequired,
  //The text to place in the alert
  content: PropTypes.string.isRequired,
  //The bold title text for the component
  heading: PropTypes.string,
  //Function to close alert when the X is clicked or escape is pressed
  onRequestClose: PropTypes.func.isRequired,
  //Pass in an Alert Size. Small or large
  size: PropTypes.string,
  //Type of icon, pass in an AlertType
  type: PropTypes.string,
  //Material icon name for icon
  iconType: PropTypes.string.isRequired,
  //Any styles to override default
  additionalStyles: PropTypes.object
};

const AlertTypes = Object.freeze({
  SUCCESS: 'alert-success',
  WARNING: 'alert-warning',
  DANGER: 'alert-danger',
  INFO: 'alert-info'
});

const AlertSizes = Object.freeze({
  SMALL: '0',
  LARGE: '2'
});

export {
  Alert,
  AlertTypes,
  AlertSizes
};